import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { copyToClipboard } from "../../utils/helpers";

export default function CopyComponent({value}) {
  const { t } = useTranslation("components");
  const [copy, setCopy] = useState(false);
  const copyText = (e, value) => {
    setCopy(true);
    e.stopPropagation();
    copyToClipboard(value);
    setTimeout(() => {
      setCopy(false);
    }, 3000);
  };
  return (
    <div className="d-inline">
      {copy ? (
        <span className="green unset-float top-unset ml-2">{t("copy.copied")}</span>
      ) : (
        <img
          title={t("copy.copy")}
          onClick={(e) => copyText(e, value)}
          className="googl-link-copy-img copy-image-animate"
          alt={t("copy.alt")}
          src="/images/copy.png"
        />
      )}
    </div>
  );
}
